<template>
  <div class="registerform__step step__two">
    <div class="step__content">
      <div class="progress-bar">
        <Progressbar
        :active="2"
        @nextStep="nextStep()"
        @updateStep="updateStep($event)"></Progressbar>
      </div>
      <div class="step__form">
        <div class="form__headline">
          <h4 class="-color-alpha" v-if="registerform.state === 0">Jetzt unverbindlich Informationen einholen</h4>
          <h4 class="-color-alpha" v-if="registerform.state === 1">Starten Sie Ihre Vermietung</h4>
          <h4 class="-color-alpha" v-if="registerform.state === 2">Heben Sie Ihre Vermietung auf die nächste Stufe</h4>
        </div>
        <div class="form__form">
          <div v-if="registerform.state === 0" class="field__wrap field__wrap--two-col field__wrap--two-col-66-33 -decreased-width">
            <div class="col col-one">
              <NumberInput
                identifier="vehicleCountPlanned-state0"
                label="Geplante Anzahl an Mietfahrzeugen:*"
                @updateValue="updateVehicleCountPlannedDirectly($event)"
                @increaseValue="updateVehicleCountPlanned('increase')"
                @decreaseValue="updateVehicleCountPlanned('decrease')"
                v-model="registerform.vehicleCountPlanned"
                :error="error && vehicleCountPlannedIsMissing"></NumberInput>
            </div>
          </div>
          <div v-if="registerform.state === 1" class="field__wrap field__wrap--two-col">
            <div class="col col-one">
              <DateInput
                identifier="rentalSinceYear"
                label="Geplanter Start der Vermietung:*"
                placeholder="JJJJ"
                v-model="registerform.plannedStartYear"
                @input="registerform.plannedStartYear = $event"
                :error="error && plannedStartYearIsMissing"></DateInput>
            </div>
            <div class="col col-two">
              <NumberInput
                identifier="vehicleCountPlanned-state1"
                label="Geplante Anzahl an Mietfahrzeugen:*"
                @updateValue="updateVehicleCountPlannedDirectly($event)"
                @increaseValue="updateVehicleCountPlanned('increase')"
                @decreaseValue="updateVehicleCountPlanned('decrease')"
                v-model="registerform.vehicleCountPlanned"
                :error="error && vehicleCountPlannedIsMissing"></NumberInput>
            </div>
          </div>
          <div v-if="registerform.state === 2" class="field__wrap field__wrap--two-col -decreased-width">
            <div class="col col-one">
              <DateInput
              identifier="rentalSinceYear"
              label="Vermietung seit:*"
              placeholder="JJJJ"
              v-model="registerform.rentalSinceYear"
              @input="registerform.rentalSinceYear = $event"
              :error="error && rentalSinceYearIsMissing"></DateInput>
            </div>
            <div class="col col-two">
              <NumberInput
                identifier="vehicleCount"
                label="Anzahl Mietfahrzeuge:*"
                @updateValue="updateVehicleCountDirectly($event)"
                @increaseValue="updateVehicleCount('increase')"
                @decreaseValue="updateVehicleCount('decrease')"
                v-model="registerform.vehicleCount"
                :error="error && vehicleCountIsMissing"></NumberInput>
            </div>
          </div>
        </div>
        <div class="form__action">
          <div class="-btn-alpha" @click="nextStep()"><span>Weiter zur Adresseingabe</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateInput from '../form/CmInputTypeDate.vue'
import NumberInput from '../form/CmInputTypeNumber.vue'
import Progressbar from '../Progressbar.vue'

export default {
  name: 'StepTwo',
  props: ['registerform'],
  data () {
    return {
      error: false
    }
  },
  components: {
    DateInput,
    NumberInput,
    Progressbar
  },
  computed: {
    rentalSinceYearIsMissing: function () {
      return !this.registerform.rentalSinceYear
    },
    plannedStartYearIsMissing: function () {
      return !this.registerform.plannedStartYear
    },
    vehicleCountIsMissing: function () {
      return !this.registerform.vehicleCount
    },
    vehicleCountPlannedIsMissing: function () {
      // return !this.registerform.vehicleCountPlanned
      return false
    },
    vehicleCountExtendingPlannedIsMissing: function () {
      // return this.registerform.vehicleCountExtendingPlanned === 'non'
      return false
    },
    vehicleCountPlannedThreeYearsIsMissing: function () {
      // return this.registerform.state === 2 && this.registerform.vehicleCountExtendingPlanned == 1 && !this.registerform.vehicleCountPlannedThreeYears || this.registerform.state === 1 && !this.registerform.vehicleCountPlannedThreeYears
      return false
    },
    allFieldsFilledForStateTwo: function () {
      return !this.rentalSinceYearIsMissing && !this.vehicleCountIsMissing && !this.vehicleCountExtendingPlannedIsMissing && !this.vehicleCountPlannedThreeYearsIsMissing
    },
    allFieldsFilledForStateZero: function () {
      return !this.vehicleCountPlannedIsMissing
    },
    allFieldsFilledForStateOne: function () {
      return !this.vehicleCountPlannedIsMissing && !this.plannedStartYearIsMissing
    }
  },
  methods: {
    updateStep: function (num) {
      switch (num) {
        case 1:
          this.$emit('updateStep', 'StepOne')
          break
        case 2:
          this.$emit('updateStep', 'StepTwo')
          break
        case 3:
          this.$emit('updateStep', 'StepThree')
          break
      }
    },
    updateVehicleCount: function (mode) {
      if (mode === 'decrease') {
        if (this.registerform.vehicleCount - 1 !== 0) {
          this.registerform.vehicleCount = parseInt(this.registerform.vehicleCount) - 1
        }
      } else {
        this.registerform.vehicleCount = parseInt(this.registerform.vehicleCount) + 1
      }
    },
    updateVehicleCountDirectly: function (val) {
      if (val !== 0) {
        this.registerform.vehicleCount = val
      }
    },
    updateVehicleCountPlannedDirectly: function (val) {
      if (val !== 0) {
        this.registerform.vehicleCountPlanned = val
      }
    },
    updateVehicleCountPlanned: function (mode) {
      if (mode === 'decrease') {
        if (this.registerform.vehicleCountPlanned - 1 !== 0) {
          this.registerform.vehicleCountPlanned = parseInt(this.registerform.vehicleCountPlanned) - 1
        }
      } else {
        this.registerform.vehicleCountPlanned = parseInt(this.registerform.vehicleCountPlanned) + 1
      }
    },
    nextStep: function () {
      if (this.registerform.state === 0) {
        if (this.allFieldsFilledForStateZero) {
          this.error = false
          this.updateStep(3)
        } else {
          this.error = true
        }
      }
      if (this.registerform.state === 1) {
        if (this.allFieldsFilledForStateOne) {
          this.error = false
          this.updateStep(3)
        } else {
          this.error = true
        }
      }
      if (this.registerform.state === 2) {
        if (this.allFieldsFilledForStateTwo) {
          this.error = false
          this.updateStep(3)
        } else {
          this.error = true
        }
      }
    }
  }
}
</script>
